module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAYAAADXYyzPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFhJREFUeNpiYBgFo2AUjAIyASOIEM1aZw+kHOhk54HX04IOMgIt1QdyLtDZwwZMQEJgAEJagQnq2w90tBRk1wFYHPODvE8niy8A4/jjaPYaBaNg6AOAAAMAhTUQBOdUZj8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/mar/50.png
// module id = 770
// module chunks = 0